import { ClipboardCheck, FileText, Truck } from "lucide-react";

const STEPS = [
  { icon: ClipboardCheck, title: "İhtiyaç Analizi & Danışmanlık", text: "Uzman ekibimiz projenize özel oda bazlı ve yıldız bazlı ekipman ihtiyacınızı çıkarır." },
  { icon: FileText, title: "Özel Teklif & Planlama", text: "24 saat içinde kişiselleştirilmiş teklifiniz ve tedarik takvimi hazır." },
  { icon: Truck, title: "Sevkiyat & Sürekli Destek", text: "Sahada kurulum desteği + açılış sonrası sarf yenileme anlaşmaları." },
];

export default function SupplyProcess() {
  return (
    <section className="section-pad bg-navy text-white" data-testid="supply-process">
      <div className="container-site">
        <div className="text-center mb-14">
          <p className="accent-script text-gold text-2xl mb-1">Süreç</p>
          <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-white">
            Tedarik Sürecimiz
          </h2>
          <p className="text-white/60 mt-3 max-w-2xl mx-auto">
            İlk temastan açılış sonrası sürekli desteğe — net ve şeffaf 3 adım.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {STEPS.map((s, i) => (
            <div key={s.title} className="rounded-xl border border-white/10 p-7 bg-white/[0.03] backdrop-blur-sm" data-testid={`supply-step-${i}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="h-12 w-12 rounded-full border border-gold text-gold flex items-center justify-center">
                  <s.icon size={20} />
                </div>
                <div className="text-gold text-3xl heading-serif font-bold">0{i + 1}</div>
              </div>
              <h3 className="heading-serif text-xl font-semibold text-white mb-2">{s.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
